import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Wall, UpdateWallDto } from 'types';
import { convertWall } from 'api/dtoConverters';

export const updateSwitch = async ({
  data,
  wallId,
}: {
  data: UpdateWallDto;
  wallId: number;
}): Promise<Wall> => {
  const response = await axios.put(`/api/walls/${wallId}`, convertWall(data));
  return response.data as Wall;
};

type UseUpdateWallOptions = {
  config?: MutationConfig<typeof updateSwitch>;
};

export const useUpdateWall = ({ config }: UseUpdateWallOptions = {}) => {
  return useMutation({
    onMutate: async (updatingWall) => {
      await queryClient.cancelQueries(['wall', updatingWall?.wallId]);

      const previousWall = queryClient.getQueryData<Wall[]>([
        'wall',
        updatingWall?.wallId,
      ]);

      queryClient.setQueryData(['wall', updatingWall?.wallId], {
        ...previousWall,
        ...updatingWall.data,
        id: updatingWall.wallId,
      });

      return previousWall;
    },
    onError: (_, __, context: any) => {
      if (context?.previousWall) {
        queryClient.setQueryData(
          ['wall', context.previousWall.wallId],
          context.previousWall
        );
      }
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries(['wall', data.id]);
      queryClient.invalidateQueries(['walls']);
    },
    ...config,
    mutationFn: updateSwitch,
  });
};
